import { Chip as MuiChip, ChipProps as MuiChipProps } from '@mui/material';
import { styled } from '@mui/material';

import { COLORS } from '~/styles/colors';

type ChipType = 'success' | 'disabled';

interface CustomChipProps extends MuiChipProps {
  type?: ChipType;
}

const basicStyles: Record<ChipType, { color: string; backgroundColor: string }> = {
  success: {
    color: COLORS.white,
    backgroundColor: COLORS.greenMain,
  },
  disabled: {
    color: COLORS.white,
    backgroundColor: COLORS.grey250,
  },
};

export default function Chip({ type, sx, ...rest }: CustomChipProps) {
  const style = type ? basicStyles[type] : {};
  return <StyledChip {...rest} sx={{ ...style, ...sx }} />;
}

export const StyledChip = styled(MuiChip)(() => ({
  height: 'unset',
  padding: '4px',
  fontWeight: 500,
  fontSize: '13px',
  lineHeight: '18px',
}));
